import React from 'react';
import './PortfolioItem.css';

import { FaPlus } from 'react-icons/fa';
import { Link } from 'react-router-dom';

// Import PhotoView from react-photo-view
import { PhotoView } from 'react-photo-view';



const PortfolioItem = (props) => {

  // Destructuring props
  const { id, image, title, category, caseStudy, className } = props;

  return (
    <div className={`portfolio-item ${className}`} key={id}>
      <div className="portfolio-content">

        {/* Portfolio Image */}
        <img src={image} alt={title} />

        {/* Portfolio Content */}
        <div className='content'>

          <div className='text'>

            {/* Portfolio Category */}
            <p>{category}</p>

            {/* Link to the individual Portfolio Detail Page */}
            <Link
              to={{
                pathname: '/Portfolio/' + title,
              }}
              state={caseStudy}
            >
              <h3>{title}</h3> {/* Portfolio Title */}
            </Link>

          </div>

          {/* Plus icon for lightbox */}
          <PhotoView src={image}>
            <div className='view'><FaPlus /></div>
          </PhotoView>

        </div>

      </div>
    </div>
  );
};

export default PortfolioItem;